// extracted by mini-css-extract-plugin
export var fullHeightState = "_21-7";
export var headerCell = "_21-1";
export var loadingStateCell = "_21-4";
export var rowWrapper = "_21-3";
export var standaloneTable = "_21-8";
export var standaloneTableWithBodyFill = "_21-9";
export var stateCell = "_21-5";
export var table = "_21-0";
export var tableBodyFiller = "_21-6";
export var white = "_21-2";